export default __webpack_public_path__ + "static/media/ST.931b30d7.svg";